import { useState } from 'react';

import { listValidations, listSubProjects } from 'services/indexer';
import { uniqueIds } from 'utils';

export default function useValidationsQuery<T>() {
  const [data, setData] = useState<T[]>([]);
  const [error] = useState<string>();
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [page, setPage] = useState(1);

  const sendQuery = async (accountId, page = 1) => {
    const limit = 10;
    const from = (page - 1) * limit;

    setIsLoading(from === 0);
    setIsLoadingMore(from > 0);

    const { result } = await listValidations(accountId, from, limit);

    const buckets = result?.aggregations?.projects?.buckets;

    if (buckets.length > 0) {
      const projectsIds = buckets
        .map((bucket) => bucket.key.project_id)
        .filter(uniqueIds);

      const { result: projects } = await listSubProjects(projectsIds);

      if (projects?.hits?.hits.length > 0) {
        setData([
          ...data,
          ...buckets.map((bucket) => {
            const project = projects.hits.hits.find(
              (p) => p._source.project_id === bucket.key.project_id
            );

            return {
              ...bucket,
              ...project._source
            };
          })
        ]);
      }
    }
    setHasMore(limit === buckets.length)
    setIsLoading(false);
    setIsLoadingMore(false);
  };

  return { data, isLoading, isLoadingMore, page, setPage, hasMore, error, refetch: sendQuery };
}
